import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { ApiConfigurationEntity } from './api-configuration.entity';
import { BaseEntity } from './base.entity';

@Index('_fk__api_configuration__id', ['fkApiConfigurationId'], {})
@Entity('_api_configuration__detail')
export class ApiConfigurationDetailEntity extends BaseEntity {
	@Column('int', {
		name: '_fk__api_configuration__id',
		nullable: true,
		unsigned: true,
	})
	public fkApiConfigurationId!: number | null;

	@Column('varchar', { name: '_location', nullable: true, length: 50 })
	public location!: string | null;

	@Column('varchar', { name: '_key', nullable: true, length: 256 })
	public key!: string | null;

	@Column('longtext', { name: '_value', nullable: true })
	public value!: string | null;

	@ManyToOne(
		() => ApiConfigurationEntity,
		(apiConfiguration) => apiConfiguration.apiConfigurationDetails,
		{ onDelete: 'RESTRICT', onUpdate: 'RESTRICT' },
	)
	@JoinColumn([
		{ name: '_fk__api_configuration__id', referencedColumnName: 'id' },
	])
	public fkApiConfiguration!: ApiConfigurationEntity;
}
